import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { useInitialized } from "../model";
import { ManagementReservationDetailInner } from "./inner";

type Props = {
	hotelID: string;
	reservationID: string;
};

export const ManagementReservationDetail = memo(({ hotelID, reservationID }: Props) => {
	const {
		//
		queryData,
		//
		// リクエスト予約を承認する
		onUpdateReservationDetailReservationRequestHandlingAccept,
		// リクエスト予約を非承認する
		onUpdateReservationDetailReservationRequestHandlingReject,
		// キャンセルの実行
		onUpdateReservationDetailCancel,
		// キャンセル料の請求
		onChargeCancelFee,
		// 返金処理の更新
		onUpdateReservationDetailUpdateRefundRequest,
		// 現地決済のキャンセル料金支払いを承認する
		onUpdateReservationLocalCancelFeeTransferAccept,
		// 現地決済のキャンセル料金支払いを非承認する
		onUpdateReservationLocalCancelFeeTransferReject,
		// お客様のステータスを更新
		onUpdateReservationDetailUpdateNoShow,
		// 領収書の発行
		onIssueReceipt,
		// 領収書のステータスを更新
		onUpdateReservationDetailUpdateIssuedReceiptStatus,
		// メアドの更新、再送信
		onUpdateReservationDetailUpdateMailResendRequest,
		// メルマガ希望の更新
		onUpdateReservationDetailUpdateMailMagazineStatus,
		// ホストメモの更新
		onUpdateReservationDetailUpdateHostMemo,
		// 過去予約履歴をクリックしたときの処理
		onClickRepeaterReservation,
	} = useInitialized(hotelID, reservationID);

	if (!queryData) {
		return <Navigate to={generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.TOP, { hotelID })} />;
	}

	return (
		<ManagementReservationDetailInner
			queryData={queryData}
			onUpdateReservationDetailReservationRequestHandlingAccept={
				onUpdateReservationDetailReservationRequestHandlingAccept
			}
			onUpdateReservationDetailReservationRequestHandlingReject={
				onUpdateReservationDetailReservationRequestHandlingReject
			}
			onUpdateReservationDetailCancel={onUpdateReservationDetailCancel}
			onChargeCancelFee={onChargeCancelFee}
			onUpdateReservationDetailUpdateRefundRequest={onUpdateReservationDetailUpdateRefundRequest}
			onUpdateReservationLocalCancelFeeTransferAccept={onUpdateReservationLocalCancelFeeTransferAccept}
			onUpdateReservationLocalCancelFeeTransferReject={onUpdateReservationLocalCancelFeeTransferReject}
			onUpdateReservationDetailUpdateNoShow={onUpdateReservationDetailUpdateNoShow}
			onIssueReceipt={onIssueReceipt}
			onUpdateReservationDetailUpdateIssuedReceiptStatus={onUpdateReservationDetailUpdateIssuedReceiptStatus}
			onUpdateReservationDetailUpdateMailResendRequest={onUpdateReservationDetailUpdateMailResendRequest}
			onUpdateReservationDetailUpdateMailMagazineStatus={onUpdateReservationDetailUpdateMailMagazineStatus}
			onUpdateReservationDetailUpdateHostMemo={onUpdateReservationDetailUpdateHostMemo}
			onClickRepeaterReservation={onClickRepeaterReservation}
		/>
	);
});
